<template>
  <div class="home" style="height: 100vh; width: 100vw; overflow: hidden">
    <div :class="isshow ? 'home-l' : 'home-l2'">
      <div class="hl-top">
        <div
          v-show="!isshow"
          style="
            width: 40px;
            height: 40px;
            margin: 20px auto 0;
            border-radius: 20px;
            overflow: hidden;
          "
        >
          <img src="../assets/img/nca1.png" style="width: 40px; height: 40px" />
        </div>
        <div class="hlt-name" v-show="isshow">网云进销存</div>
        <div class="hlt-time" v-show="isshow">
          <div style="line-height: 15px">当前版本：</div>
          <div style="line-height: 15px">2022-11-25 19:20</div>
          <div class="hl-fixe4"></div>
        </div>
      </div>
      <div
        class="hl-mitem"
        v-for="(i, index) in toolList"
        :key="index"
        @click="toBG(i.name)"
      >
        <i class="iconfont htool" :class="i.icon"></i>
        <div v-show="isshow" style="padding-left: 20px">{{ i.name }}</div>
        <div class="icon-act">◆</div>
        <div class="hlmi-group">
          <!-- :class="i.name == '设置' ? 'hlmi-group2' : 'hlmi-group'"  -->
          <!-- :style="i.name == '办公' ? 'width:0;height:0' : ''" -->
          <!-- || i.name == '资料'  -->
          <div
            v-for="(i1, index1) in i.children"
            :key="index1"
            class="hlmig-item"
          >
            <div class="hlmigi-title">{{ i1.name }}</div>
            <div
              v-for="(i2, index2) in i1.list"
              :key="index2"
              class="hlmigi-i"
              @click="toPage(i2)"
            >
              {{ i2.name }}
              <i
                class="iconfont tool-hot"
                v-if="i2.ishot"
                style="margin-left: 5px; font-size: 16px"
              ></i>
              <span
                v-if="i2.fnaviid == 2111"
                style="font-size: 12px; color: #4283fb"
                @click.stop="
                  toPage({ name: '快速报价', code: 'ksbj', fnaviid: 2112 })
                "
                >（快速报价）</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="hl-bottom" v-show="isshow">
        <div>网云技术出品</div>
        <div>NetCloud Technology</div>
      </div>
      <div class="hl-fixe" @click="changeIsshow">
        <i
          class="iconfont"
          style="font-size: 20px"
          :class="isshow ? 'htoolsq' : 'htoolzk'"
        ></i>
      </div>
      <div class="hl-fixe2"></div>
      <div class="hl-fixe3"></div>
    </div>
    <!-- 第二部分 -->
    <!-- window.innerWidth-150 -->
    <div class="home-r" :style="{ width: mainWidth + 'px' }">
      <!-- <div class="home-r" :style="{width:screenWidth-this.$Store.state.leftWidth+'px'}"> -->
      <!-- <div class="home-r"> -->
      <div class="hr-top">
        <div class="hrt-l">
          {{ company.linkname }}
        </div>
        <div class="hrt-r">
          <div class="hrtr-item userinfo">
            <div class="userimg"><img :src="userImg" /></div>
            <!-- <div class="userimg"><img src="../assets/img/back.png" alt=""></div> -->
            <div class="username">
              {{ userinfo.fnickname }}{{ userinfo.fmobile }}
            </div>
            <!-- <div class="usericon"><i class="iconfont icon_xiangxia"></i></div> -->
            <div class="usericon" style="height: 60px; cursor: pointer">
              <el-dropdown
                trigger="click"
                @command="handleCommand1"
                style="
                  outline: none;
                  border: none;
                  overflow: hidden;
                  width: 30px;
                "
              >
                <div class="dropdown">
                  <i class="iconfont icon_xiangxia"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="closeNow"
                    >登录时间：{{ loginTime }}</el-dropdown-item
                  >
                  <el-dropdown-item command="erpCom">挂靠企业</el-dropdown-item>
                  <el-dropdown-item command="kcmCom">绑定KCM</el-dropdown-item>
                  <el-dropdown-item command="bossQuit"
                    >退出团队</el-dropdown-item
                  >
                  <el-dropdown-item command="changeColor"
                    >更改主题</el-dropdown-item
                  >
                  <el-dropdown-item command="changename"
                    >更改昵称</el-dropdown-item
                  >
                  <el-dropdown-item>
                    <div style="position: relative; height: 38px">
                      更换头像
                      <el-upload
                        action=""
                        accept="image/png"
                        :on-change="onUploadChange"
                        :auto-upload="false"
                        :show-file-list="false"
                      >
                        <el-button
                          slot="trigger"
                          size="small"
                          type="primary"
                          style="
                            position: absolute;
                            top: 0;
                            left: 0;
                            height: 40px;
                            width: 230px;
                            opacity: 0;
                          "
                          >更换头像</el-button
                        >
                      </el-upload>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div
            class="hrtr-item tb-group"
            v-if="company.linkid == '2100000000001'"
          >
            <div
              class="top-btn1"
              :style="'border:' + ssbgcolor + ' 1px solid;color:' + ssbgcolor"
            >
              试用
            </div>
            <div
              class="top-btn2"
              :style="
                'border:' +
                ssbgcolor +
                ' 1px solid;background-color:' +
                ssbgcolor
              "
            >
              购买
            </div>
          </div>
          <!-- <div class="hrtr-item curp"><i class="iconfont right-t tel1"></i>联系我们</div> -->
          <div class="hrtr-item curp" @click="toHelp">
            <i class="iconfont right-t tool-help"></i>帮助中心
          </div>
          <div class="hrtr-item curp">
            <i class="iconfont right-t tel2"></i
            ><a href="tencent://message/?uin=402898490&Site=Sambow&Menu=yes"
              >技术支持</a
            >
          </div>
          <div class="hrtr-item curp" @click="loginOut">
            <i class="iconfont right-t hoolc"></i>
          </div>
        </div>
      </div>
      <!-- <div class="hr-top2" :style="{width:screenWidth-this.$Store.state.leftWidth+'px'}"> -->
      <!-- <div class="hr-top2"> -->
      <!-- <div class="hr-top2" :style="{width:mainWidth+'px'}"> -->
      <div class="hr-top2">
        <div
          :class="
            historyIndex == -1 || historyList.length == 0
              ? 'acthis-item'
              : 'his-item'
          "
          :style="
            historyIndex == -1 || historyList.length == 0
              ? 'background:' + ssbgcolor
              : ''
          "
          @click="toHome"
        >
          首页
        </div>
        <div
          v-for="(i, index) in historyList"
          :key="i.code"
          :class="historyIndex == index ? 'acthis-item1' : 'his-item1'"
          :style="historyIndex == index ? 'background:' + ssbgcolor : ''"
          @click="historyTo(i, index)"
        >
          <span class="his-name">{{ i.name }}</span>
          <i
            class="iconfont hisgb"
            style="font-size: 14px"
            @click.stop="closeOne(i, index)"
          ></i>
        </div>
        <div style="width: 30px">
          <el-dropdown
            trigger="click"
            @command="handleCommand"
            style="outline: none; border: none; overflow: hidden; width: 30px"
          >
            <div class="dropdown">
              <i class="iconfont icon_xiangxia"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
              <el-dropdown-item command="closeNow">关闭当前</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- <div class="dropdown"> -->

      <!-- </div> -->
      <div class="hr-main" :style="{ height: screenHeight - 95 + 'px' }">
        <keep-alive>
          <router-view
            ref="rout"
            :newlist="historyList"
            :screenWidth="screenWidth"
            :screenHeight="screenHeight"
            v-if="$route.meta.keepAlive"
            @toadd="toAddzl"
            @topage="useoftenTo"
            @topage2="useoftenTo2"
            @closeCurrentPage="closeCurrentPage"
          />
        </keep-alive>
        <router-view
          ref="rout1"
          :newlist="historyList"
          v-if="!$route.meta.keepAlive"
          @topage="useoftenTo"
        />
        <!-- <router-view/> -->
      </div>
    </div>
    <vxe-modal v-model="showcolor" title="选择颜色">
      <template>
        <div
          class="model-b"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <el-color-picker v-model="ssbgcolor1"></el-color-picker>
          <div>
            <vxe-button
              status="primary"
              :style="
                'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1
              "
              @click="comfirmColor"
              content="确认"
            ></vxe-button>
            <vxe-button content="取消" @click="cancelColor"></vxe-button>
          </div>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="showxtpz">
      <template>
        <div style="font-size: 16px; margin-bottom: 10px">请输入模块密码：</div>
        <div
          class="model-b"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <vxe-input
            v-model="xtpzcode"
            placeholder="请输入"
            style="margin: 0 5px; width: 230px"
          />
          <vxe-button
            status="primary"
            :style="
              'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1
            "
            @click="comfirmxtpz"
            content="确认"
          ></vxe-button>
          <vxe-button content="取消" @click="cancelxtpz"></vxe-button>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="showkcmCom" title="绑定kcm">
      <template>
        <div
          class="model-b"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <div>用户名称:</div>

          <vxe-input
            v-model="kcmComObj.fusername"
            placeholder="请输入"
            style="margin: 0 5px; flex: 1"
          />
        </div>
        <div
          class="model-b"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <div>经办业务:</div>

          <vxe-input
            v-model="kcmComObj.fworkername"
            placeholder="请输入"
            style="margin: 0 5px; flex: 1"
          />
        </div>
        <div
          class="model-b"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <div>往来单位:</div>

          <vxe-input
            v-model="kcmComObj.fcsname"
            placeholder="请输入"
            style="margin: 0 5px; flex: 1"
          />
        </div>
        <div style="text-align: right">
          <vxe-button
            status="primary"
            :style="
              'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1
            "
            :disabled="hasKcm"
            @click="comfirmKcm"
            content="绑定关系"
          ></vxe-button>
          <vxe-button
            content="解除关系"
            @click="comfirmKcm2"
            :disabled="!hasKcm"
          ></vxe-button>
          <vxe-button
            content="设置用户"
            @click="showkcmUser"
            :disabled="!hasKcm"
          ></vxe-button>
          <vxe-button content="关闭" @click="cancelKcm"></vxe-button>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="iskcmUser" width="720" height="600" title="绑定用户">
      <template>
        <div>所有用户(双击添加)</div>
        <div
          class="model-b"
          style="
            display: flex;
            margin-bottom: 10px;
            flex-wrap: wrap;
            width: 670px;
            height: 150px;
          "
        >
          <div
            v-for="(item, index) in userListAll"
            @dblclick="addListOne(item)"
            :key="index"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            "
          >
            <div>{{ item.fnickname }}</div>
            <div style="font-size: 12px; color: #888">{{ item.fmobile }}</div>
          </div>
        </div>
        <div>已包含用户(双击删除)</div>
        <div
          class="model-b"
          style="
            display: flex;
            margin-bottom: 10px;
            flex-wrap: wrap;
            width: 670px;
            height: 150px;
          "
        >
          <div
            v-for="(item, index) in userListhave"
            @dblclick="delListOne(item)"
            :key="index"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            "
          >
            <div>{{ item.fusername }}</div>
            <div style="font-size: 12px; color: #888">{{ item.fuserid }}</div>
          </div>
        </div>
        <div>待添加用户(双击移除)</div>
        <div
          class="model-b"
          style="display: flex; margin-bottom: 10px; height: 30px"
        >
          <div
            v-for="(item, index) in userListtoadd"
            @dblclick="deladdtOne(index)"
            :key="index"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            "
          >
            <div>{{ item.fnickname }}</div>
          </div>
        </div>
        <div>待删除用户(双击移除)</div>
        <div
          class="model-b"
          style="display: flex; margin-bottom: 10px; height: 30px"
        >
          <div
            v-for="(item, index) in userListtodel"
            @dblclick="deldeltOne(index)"
            :key="index"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 3px 7px;
              cursor: pointer;
            "
          >
            <div>{{ item.fusername }}</div>
          </div>
        </div>
        <div style="text-align: right">
          <vxe-button
            :style="
              'background-color:' + ssbgcolor1 + ';border-color:' + ssbgcolor1
            "
            content="保存"
            @click="savekcmUser"
          ></vxe-button>
          <vxe-button content="关闭" @click="closekcmUser"></vxe-button>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="showerpCom" width="680" height="400" title="挂靠企业">
      <template>
        <div
          style="
            border-bottom: 1px solid #888;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 5px 0;
          "
        >
          当前挂靠企业：{{ erpComObj.fname }}
          <vxe-button
            content="退出当前企业"
            @click="erpcomClick('1')"
          ></vxe-button>
        </div>
        <div
          class="model-b"
          style="display: flex; justify-content: space-between"
        >
          <div
            style="
              border-right: 1px solid #888;
              width: 190px;
              height: 280px;
              padding: 0 5px;
            "
          >
            <vxe-input
              v-model="erplinkid"
              placeholder="请输入企业内码"
              style="margin: 10px 0 5px; width: 100%"
            />
            <vxe-input
              v-model="erplinkname"
              placeholder="请输入企业名称"
              style="margin: 5px 0; width: 100%"
            />
            <vxe-button
              status="primary"
              :style="
                'margin:5px 0;width:100%;background-color:' +
                ssbgcolor1 +
                ';border-color:' +
                ssbgcolor1
              "
              @click="erpcomClick('2')"
              content="申请加入该企业"
            ></vxe-button>
            <vxe-button
              status="primary"
              :style="
                'margin:5px 0;width:100%;background-color:' +
                ssbgcolor1 +
                ';border-color:' +
                ssbgcolor1
              "
              @click="erpcomClick('3')"
              content="同意加入该企业"
            ></vxe-button>
            <vxe-button
              content="拒绝加入该企业"
              style="margin: 5px 0; width: 100%"
              @click="erpcomClick('4')"
            ></vxe-button>
            <vxe-button
              content="撤销该企业申请"
              style="margin: 5px 0; width: 100%"
              @click="erpcomClick('1')"
            ></vxe-button>
          </div>
          <div
            style="
              position: relative;
              max-height: 250px;
              overflow-y: auto;
              width: 100%;
            "
          >
            <div
              style="
                height: 30px;
                font-weight: 600;
                position: absolute;
                left: 10px;
                top: 0;
              "
            >
              待处理企业：
            </div>
            <div style="height: 30px"></div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                line-height: 30px;
                height: 30px;
                overflow-y: auto;
              "
            >
              <div
                style="margin: 0 10px"
                v-for="(item, index) in erpComlist"
                @click="erpcomClick('5', item)"
                :key="index"
              >
                {{ item.fname }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="showname" title="输入昵称">
      <template>
        <div
          class="model-b"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <vxe-input v-model="fnickname" />
          <div>
            <vxe-button
              status="primary"
              :style="
                'background-color:' + ssbgcolor + ';border-color:' + ssbgcolor
              "
              @click="comfirmName"
              content="确认"
            ></vxe-button>
            <vxe-button content="取消" @click="cancelName"></vxe-button>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import TopMode from "../components/topMode";
import TopUser from "../components/topuser";
import History from "../components/History";
import Axios from "axios";
import router from "@/router/index.js";
import ObsClient from "../../dist/esdk-obs-browserjs-without-polyfill-3.19.5.min.js";
var obsClient;
export default {
  components: {
    History,
    TopMode,
    TopUser,
  },
  data() {
    return {
      userListhave: [],
      userListtoadd: [],
      userListtodel: [],
      userListAll: [],
      xtpzcode: "",
      hasKcm: false,
      showxtpz: false,
      erpComObj: {},
      erpComlist: [],
      showkcmCom: false,
      kcmComObj: {
        fuserid: -1,
        fusername: "",
        fworkerid: -1,
        fworkername: "",
        fcsid: -1,
        fcsname: "",
      },
      iskcmUser: false,
      showerpCom: false,
      erplinkid: "",
      erplinkname: "",
      isAsadmin: false,
      fnickname: "",
      showcolor: false,
      showname: false,
      ssbgcolor: this.$Store.state.bgcolor,
      ssbgcolor1: this.$Store.state.bgcolor,
      loginTime: "",
      company: {},
      userinfo: {},
      userImg: "",
      historyIndex: -1,
      historyList: [],
      mainWidth: window.innerWidth - 150,
      screenHeight: window.innerHeight,
      isshow: true,
      toolList: this.$Datalist.toolList,
      systemName: "进销存管理系统",
      toplist: this.$Datalist.list, // 导航数据
      sort_books: [], // 侧边导航数据
      asideShow: false, // 关闭侧边栏
      topSelectArray: ["主页"], // top 选中头部导航数据
      leftSelectArray: [], // left 选中侧边导航数据
      count: 0,
      tabLists: [], // 路由栈
      tabSelect: {}, // 选中路由栈
      screenWidth: window.innerWidth,
      agtkcmapi:"https://app.ncerp.cn:29601/api/kcm/",
    };
  },
  computed: {},
  created() {
    if(localStorage.getItem("agtkcmapi")){
	  		  this.agtkcmapi = localStorage.getItem("agtkcmapi")
	  }
    // this.log('sss',this.$router.options.routes[0].children)
    // this.topSelectArray = []
    // this.leftSelectArray = []
    this.loginTime = localStorage.getItem("agtlogintime");
    this.$axios.defaults.headers["token"] = localStorage.getItem("agttoken");
    if (sessionStorage.getItem("historyList")) {
      this.historyList = JSON.parse(sessionStorage.getItem("historyList"));
      this.historyIndex = sessionStorage.getItem("historyIndex");
      this.log(this.historyList, this.historyIndex);
      if (this.historyList[this.historyIndex]) {
        let id = this.historyList[this.historyIndex].fnaviid;
        this.$Store.dispatch("onchangSetnaviid", id);
        this.$Store.dispatch(
          "onchangSetnaviName",
          this.historyList[this.historyIndex].name
        );
      }
    }

    this.getCompany();
    this.getauth();
    this.findUser();
    this.log("22222");
    // this.$router.push("/home")
    this.userinfo = JSON.parse(localStorage.getItem("agtuserinfo"));
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));

    //
    if (!this.isAsadmin) {
      this.toolList.forEach((tool) => {
        if (tool.name == "设置") {
          tool.children[0].list.forEach((item, index) => {
            if (item.name == "系统配置" || item.name == "报表设计") {
              tool.children[0].list.splice(index, 1);
            }
          });
        }
      });
    }
  },
  destroyed() {
    // 组件销毁后解绑事件
    window.onresize = null;
  },
  mounted() {
    this.mainWidth = window.innerWidth - 150;
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = window.innerWidth;
        this.mainWidth = window.innerWidth - 150;
        this.$Store.dispatch("onchangLeftWidth", 150);
        this.$Store.dispatch("onchanghtmlWidth", window.innerWidth);
        this.$Store.dispatch("onchanghtmlHeight", window.innerHeight);
        if (!this.isshow) {
          this.mainWidth = window.innerWidth - 50;
          this.$Store.dispatch("onchangLeftWidth", 50);
        }
        this.log("this.mainWidth===", this.mainWidth);
        this.screenHeight = window.innerHeight;
      })();
    };
    if (localStorage.getItem("agtsscolor")) {
      this.$Store.dispatch("onchangColor", localStorage.getItem("agtsscolor"));
    }
    obsClient = new ObsClient({
      access_key_id: "QTEZALFEWXYLBIPF1ZXH",
      secret_access_key: "hgh3XEUxF0bqt2Klu9DNbnG9goAdj2HqoHFL8RfK",
      server: "https://obs.cn-south-1.myhuaweicloud.com",
    });
    this.log(obsClient);
    // 监听鼠标
    document.onmousemove = (event) => {
      let x1 = event.clientX;
      let y1 = event.clientY;
      if (this.x !== x1 || this.y !== y1) {
        this.count = 0;
      }
      this.x = x1;
      this.y = y1;
    };
    // 监听键盘
    document.onkeydown = () => {
      this.count = 0;
    };

    // 监听Scroll
    document.onscroll = () => {
      this.count = 0;
    };
    window.onbeforeunload = (e) => {
      this.log("onbeforeunload", this.$route.path.split("/")[2]); //刷新时弹出提示
      sessionStorage.setItem("routerhistory", this.$route.path.split("/")[2]);
      if (this.$refs.rout) {
        let rout = this.$refs.rout.$refs.page;
        if (rout) {
          sessionStorage.setItem("topname", rout.topName);
        }
      }
      // return ''
      // this.$router.push('/admin')
    };
    // this.setTimer();

    this.listenPage();
  },
  methods: {
    savekcmUser() {
      let arr = [];
      let arr1 = [];
      this.userListtoadd.forEach((el) => {
        let obj = {
          fuserid: Number(el.fmobile),
          fusername: el.fnickname,
          fauth: [],
          fmore: {},
        };
        arr.push(obj);
      });
      this.userListtodel.forEach((el) => {
        arr1.push(el.fuserid);
      });
      let data = {
        visit: "web",
        system: "kcm",
        agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        data: arr,
      };
      let data1 = {
        visit: "web",
        system: "kcm",
        agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        data: arr1,
      };
      //this.$axios.post('https://app.ncerp.cn:9611/kcm/agent/user/add',data).then(res=>{
      this.$axios
        .post(this.agtkcmapi+"agent/user/add", data)
        .then((res) => {
          if (res.data.code == "0") {
            this.$message.success("添加成功");
            if (JSON.stringify(arr1) != "[]") {
              //this.$axios.post('https://app.ncerp.cn:9611/kcm/agent/user/del',data1).then(ress=>{
              this.$axios
                .post(this.agtkcmapi+"agent/user/del", data1)
                .then((ress) => {
                  if (ress.data.code == "0") {
                    this.$message.success("删除成功");
                    this.getKcmobj();
                    this.iskcmUser = false;
                    this.userListtoadd = [];
                    this.userListtodel = [];
                  } else {
                    this.$message.error(ress.data.message);
                  }
                });
            } else {
              this.iskcmUser = false;
              this.getKcmobj();
              this.userListtoadd = [];
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    closekcmUser() {
      this.iskcmUser = false;
      this.userListtoadd = [];
      this.userListtodel = [];
    },
    addListOne(item) {
      this.userListtoadd.push(item);
    },
    delListOne(item) {
      this.userListtodel.push(item);
    },
    deldeltOne(index) {
      this.userListtodel.splice(index, 1);
    },
    deladdtOne(index) {
      this.userListtoadd.splice(index, 1);
    },
    findUser() {
      Axios.post("user/list/find", { system: "agt", visit: "web" }).then(
        (res) => {
          if (res.data.code == "0") {
            this.log(res.data.data);
            this.userListAll = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        }
      );
    },
    showkcmUser() {
      this.iskcmUser = true;
    },
    comfirmKcm2() {
      //解除
      this.$confirm("确定解除关系吗").then(() => {
        //this.$axios.post('https://app.ncerp.cn:9611/kcm/agent/bind/del',{
        this.$axios
          .post(this.agtkcmapi+"agent/bind/del", {
            visit: "web",
            system: "kcm",
            agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
          })
          .then((res) => {
            if (res.data.code == "0") {
              this.$message.error("解除成功");
              this.kcmComObj = {};
              this.showkcmCom = false;
              this.hasKcm = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
      });
    },
    comfirmKcm() {
      let data = {
        visit: "web",
        system: "kcm",
        agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        data: {
          fuserid: -1,
          fusername: this.kcmComObj.fusername,
          fworkerid: -1,
          fworkername: this.kcmComObj.fworkername,
          fcsid: -1,
          fcsname: this.kcmComObj.fcsname,
        },
      };
      //this.$axios.post('https://app.ncerp.cn:9611/kcm/agent/bind/set',data).then(res=>{
      this.$axios
        .post(this.agtkcmapi+"agent/bind/set", data)
        .then((res) => {
          if (res.data.code == "0") {
            this.log(res.data.data);
            this.$message.success("绑定成功");
            this.cancelKcm();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    cancelKcm() {
      this.showkcmCom = false;
      this.kcmComObj = {
        fuserid: -1,
        fusername: "",
        fworkerid: -1,
        fworkername: "",
        fcsid: -1,
        fcsname: "",
      };
    },
    toBG(e) {
      if (e == "办公") {
        let isFirst = false;
        let index1 = -1;
        this.historyList.forEach((el, index) => {
          if (el.name == "轻办公") {
            isFirst = true;
            index1 = index;
          }
        });
        if (!isFirst) {
          this.historyList.push({
            name: "轻办公",
            code: "yhbg",
            fnaviid: 2231,
          });
          this.historyIndex = this.historyList.length - 1;
        } else {
          this.historyIndex = index1;
        }

        // this.$Store.dispatch('onchangSetnaviid','2231')
        // this.$Store.dispatch('onchangSetnaviName','系统配置')
        this.$Store.dispatch("onchangIsfirst", false);
        this.$router.push("/home/yhbg");
      }
    },
    comfirmxtpz() {
      if (this.xtpzcode == "修改系统配置") {
        this.showxtpz = false;
        this.historyList.push({
          name: "系统配置",
          code: "xtpz",
          fnaviid: 2231,
        });
        this.historyIndex = this.historyList.length - 1;
        this.$Store.dispatch("onchangSetnaviid", "2231");
        this.$Store.dispatch("onchangSetnaviName", "系统配置");
        this.$Store.dispatch("onchangIsfirst", false);
        this.$router.push("/home/xtpz");
      } else {
        this.message.error("密码错误，请重新输入");
      }
    },
    cancelxtpz() {
      this.showxtpz = false;
    },
    geterpList() {
      let data = {
        visit: "web",
        system: "agt",
      };
      this.$axios.post("boss/linktoerp/data", data).then((res) => {
        if (res.data.code == 0) {
          this.log(res.data.data);
          if (res.data.data) {
            if (res.data.data.fstatus == "accepted") {
              this.erpComObj = res.data.data;
            } else if (res.data.data.fstatus == "waiting") {
              this.erpComlist.push(res.data.data);
            }
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    erpcomClick(e, item) {
      if (e == "1") {
        let data = {
          visit: "web",
          system: "agt",
        };
        this.$axios.post("boss/linktoerp/remove", data).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("已解除当前挂靠企业");
            this.erpComObj = {};
            this.erplinkname = "";
            this.erplinkid = "";
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (e == "2") {
        let data = {
          visit: "web",
          system: "agt",
          erplinkid: -1,
          erplinkname: this.erplinkname,
        };
        if (this.erplinkid) {
          data.erplinkid = Number(this.erplinkid);
        }
        this.$axios.post("boss/linktoerp/create", data).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("申请成功，等待处理");
            this.erplinkname = "";
            this.erplinkid = "";
            this.showerpCom = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (e == "3") {
        let data = {
          visit: "web",
          system: "agt",
          erplinkid: Number(this.erplinkid),
          status: "accepted",
        };
        this.$axios.post("boss/linktoerp/confirm", data).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.erpComObj.fname = this.erplinkname;
            this.erplinkname = "";
            this.erplinkid = "";
            this.showerpCom = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (e == "4") {
        let data = {
          visit: "web",
          system: "agt",
        };
        this.$axios.post("boss/linktoerp/remove", data).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("已拒绝该企业申请");
            this.erpComlist = [];
            this.erplinkname = "";
            this.erplinkid = "";
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (e == "5") {
        this.erplinkname = item.fname;
        this.erplinkid = item.flinkid;
      }
    },
    getauth() {
      this.log("432", JSON.parse(localStorage.getItem("agtuserinfo")));
      if (localStorage.getItem("agtuserinfo")) {
        if (JSON.parse(localStorage.getItem("agtuserinfo")).fconfig) {
          if (JSON.parse(localStorage.getItem("agtuserinfo")).fconfig.auth) {
            if (
              JSON.parse(localStorage.getItem("agtuserinfo")).fconfig.auth.agt
            ) {
              this.isAsadmin = JSON.parse(
                localStorage.getItem("agtuserinfo")
              ).fconfig.auth.agt.asadmin;
            }
          }
        }
      }
    },
    onUploadChange(file) {
      this.log(file);
      //  return
      this.uploadPic(file.raw, file.name);
      // this.setObs(file.raw,file.name)
    },
    uploadPic(e, e1) {
      let data = {
        system: "agt",
        visit: "web",
        userid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
        linkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        naviid: -1,
        lockuser: true,
      };
      this.$axios.post("obs/create", data).then((res) => {
        if (res.data.code == 0) {
          this.log(res.data.data);
          this.setObs(res.data.data, e, e1);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    setObs(data, file, name) {
      //上传文件，带类型
      this.log("file", file);
      this.log("file", name);
      let that = this;
      let arrr = name.split(".");
      let type = name.split(".")[arrr.length - 1];
      let str = `${data.path}${data.file}.${type}`;
      this.log(str);
      // this.retObs(data,name,type,file.size)
      // return
      obsClient.putObject(
        {
          Bucket: data.bucket,
          Key: str,
          SourceFile: file,
          PartSize: 9 * 1024 * 1024,
          TaskNum: 3,
          ContentType: file.type,
          ACL: obsClient.enums.AclPublicRead,
          ProgressCallback: function (transferredAmount, totalAmount) {},
          EventCallback: function (eventType, eventParam, eventResult) {},
          ResumeCallback: function (resumeHook, uploadCheckpoint) {},
        },
        // 成功、失败回调函数
        function (err, result) {
          if (err) {
            this.log("err", err);
            this.$message.error("err", err);
          } else {
            this.log("success", result);
            that.retObs(data, name, type, file.size);
          }
        }
      );
    },
    retObs(e, e1, e2, e3) {
      this.log("11123");
      let data = {
        system: "agt",
        visit: "web",
        lockto: "user",
        keyword: "head",
        douserid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
        linkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        naviid: -1,
        billid: -1,
        dataid: -1,
        data: [
          {
            bucket: e.bucket,
            path: e.path,
            file: e.file,
            type: `.${e2}`,
            size: e3,
            title: e1,
          },
        ],
      };
      this.$axios.post("obs/upload", data).then((res) => {
        if (res.data.code == 0) {
          this.delImg();

          // this.getObs(data.data[0]);
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.log(data);
    },
    delImg() {
      let arr = [];
      if (JSON.parse(localStorage.getItem("agtuserinfo")).ffile) {
        JSON.parse(localStorage.getItem("agtuserinfo")).ffile.forEach((el) => {
          if (el.keyword == "head") {
            el.data.forEach((ell) => {
              let item = {
                bucket: ell.bucket,
                path: ell.path,
                file: ell.file,
                type: ell.type,
              };
              arr.push(item);
            });
          }
        });
        let data = {
          system: "agt",
          visit: "web",
          lockto: "user",
          douserid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
          linkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
          keyword: "head",
          naviid: -1,
          billid: -1,
          dataid: -1,
          bucket: "ncktc",
          data: arr,
        };
        this.$axios
          .post("obs/delete", data)
          .then((res) => {
            if (res.data.code == 0) {
              this.$message.success("修改成功，请重新登录");
              setTimeout(() => {
                const agtmainapi = JSON.parse(
                  JSON.stringify(localStorage.getItem("agtmainapi"))
                );
                const agtkcmapi = JSON.parse(
                  JSON.stringify(localStorage.getItem('agtkcmapi'))
                );
                localStorage.clear();
                localStorage.setItem("agtmainapi", agtmainapi);
                localStorage.setItem("agtkcmapi", agtkcmapi);
                this.$router.replace("/");
              }, 1500);
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((e) => {
            this.log(JSON.stringify(e));
          });
      }
    },
    comfirmColor() {
      this.$Store.dispatch("onchangColor", this.ssbgcolor1);
      localStorage.setItem("agtsscolor", this.ssbgcolor1);
      this.ssbgcolor = this.ssbgcolor1;
      if (this.$refs.rout) {
        if (this.$refs.rout.ssbgcolor) {
          this.$refs.rout.ssbgcolorr = this.ssbgcolor1;
        }
      }
      if (this.$refs.rout1) {
        if (this.$refs.rout1.ssbgcolor) {
          this.$refs.rout1.ssbgcolorr = this.ssbgcolor1;
        }
      }

      this.showcolor = false;
      this.$message.success("更改成功，请刷新网页");
    },
    cancelColor() {
      this.ssbgcolor1 = this.ssbgcolor;
      this.showcolor = false;
    },
    cancelName() {
      this.fnickname = "";
      this.showname = false;
    },
    comfirmName() {
      let data = {
        system: "agt",
        visit: "web",
        douserid: JSON.parse(localStorage.getItem("agtuserinfo")).fuserid,
        domobile: JSON.parse(localStorage.getItem("agtuserinfo")).fmobile,
        data: {
          nickname: this.fnickname,
        },
      };
      this.$axios.post("user/nickname/save", data).then((res) => {
        if (res.data.code == 0) {
          this.fnickname = "";
          this.showname = false;
          this.$message.success("修改成功,请重新登录");
          setTimeout(() => {
            const agtmainapi = JSON.parse(
              JSON.stringify(localStorage.getItem("agtmainapi"))
            );
            const agtkcmapi = JSON.parse(
              JSON.stringify(localStorage.getItem("agtkcmapi"))
            );
            localStorage.clear();
            localStorage.setItem("agtmainapi", agtmainapi);
            localStorage.setItem("agtkcmapi", agtkcmapi);
            this.$router.replace("/");
          }, 1500);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    beforeunloadFn(e) {
      sessionStorage.setItem("historyList", JSON.stringify(this.historyList));
      sessionStorage.setItem("historyIndex", this.historyIndex);
    },
    toAddzl(e) {
      this.log("182home", e, this.historyList);
      let id = e;
      let code = "";
      let name = "";
      if (e == 4132) {
        code = "gfzl";
        name = "供方资料";
      } else if (e == 4131) {
        code = "khzl";
        name = "客户资料";
      } else if (e == 4111) {
        code = "spzl";
        name = "商品资料";
      } else if (e == 4113) {
        code = "bmyg";
        name = "部门员工";
      }
      if (e == 4132 || e == 4111 || e == 4131 || e == 4113) {
        this.$Store.dispatch("onchangSetnaviid", id);
        this.$Store.dispatch("onchangSetnaviName", name);
        this.$router.push("/home/" + code);
        let isHave = false;
        this.historyList.forEach((el, index) => {
          if (el.code == code) {
            isHave = true;
            this.historyIndex = index;
          }
        });
        if (!isHave) {
          let obj = {
            code: code,
            fnaviid: id,
            name: name,
          };
          this.historyList.push(obj);
          this.historyIndex = this.historyList.length - 1;
        }
      }
    },
    useoftenTo(e) {
      this.log("home", e);
      this.toPage(e);
    },
    useoftenTo2(e) {
      this.log(e);
      this.toPage2(e);
    },
    handleCommand(e) {
      if (e == "closeAll") {
        this.closeAll();
      } else {
        this.closeNow();
      }
    },
    getKcmobj() {
      this.$axios
        //.post("https://app.ncerp.cn:9611/kcm/agent/find", {
        .post(this.agtkcmapi+"agent/find", {
          visit: "web",
          system: "kcm",
          agtlinkid: JSON.parse(localStorage.getItem("agtcominfo")).linkid,
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.log(res.data.data);
            if (JSON.stringify(res.data.data) != "{}") {
              this.kcmComObj = res.data.data.fdata;
              this.userListhave = res.data.data.fuser;
              this.hasKcm = true;
              this.showkcmCom = true;
            } else {
              this.hasKcm = false;
              this.kcmComObj = {
                fuserid: -1,
                fusername: "",
                fworkerid: -1,
                fworkername: "",
                fcsid: -1,
                fcsname: "",
              };
              this.showkcmCom = true;
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    handleCommand1(e) {
      if (e == "changeColor") {
        this.showcolor = true;
      } else if (e == "changename") {
        this.showname = true;
      } else if (e == "bossQuit") {
        this.$confirm("确定要退出公司团队吗").then(() => {
          let data = {
            visit: "web",
            system: "agt", //可传erp,agt,ncx,ncv,nco,nshop,kjxc,kfin,kcode,kbiz,koa
            domobile: JSON.parse(localStorage.getItem("agtuserinfo")).fmobile, //加入人的手机号
            douserid: -1, //申请人的用户内码，如果传了手机号，这里传-1即可
          };
          this.$axios.post("boss/quit", data).then((res) => {
            if (res.data.code == 0) {
              this.$message.success("退出成功,请加入团队");
              setTimeout(() => {
                const agtmainapi = JSON.parse(
                  JSON.stringify(localStorage.getItem("agtmainapi"))
                );
                const agtkcmapi = JSON.parse(
                  JSON.stringify(localStorage.getItem("agtkcmapi"))
                );
                localStorage.clear();
                localStorage.setItem("agtmainapi", agtmainapi);
                localStorage.setItem("agtkcmapi", agtkcmapi);
                this.$router.replace("/");
              }, 1500);
            } else {
              this.$message.error(res.data.message);
            }
          });
        });
      } else if (e == "erpCom") {
        if (this.isAsadmin) {
          this.showerpCom = true;
          this.erpComObj = {};
          this.erplinkname = "";
          this.erplinkid = "";
          this.erpComlist = [];
          this.geterpList();
        } else {
          this.$message.error("当前账号暂无该操作权限");
        }
      } else if (e == "kcmCom") {
        if (this.isAsadmin) {
          this.getKcmobj();
        } else {
          this.$message.error("当前账号暂无该操作权限");
        }
      }
    },
    getCompany() {
      let bossinfo = JSON.parse(localStorage.getItem("agtuserinfo")).fconfig;
      this.company = bossinfo.link.agt;
      localStorage.setItem("agtcominfo", JSON.stringify(this.company));
      // let url=`boss/info/find?linkid=${bossinfo.flinkid}`
      // this.$axios.get(url).then(res=>{
      // 	if(res.data.code == '0'){
      //     this.log(res.data.data)
      //     localStorage.setItem('cominfo',res.data.data)
      //     this.company=res.data.data
      // 	}else{
      // 		this.$message.error(res.data.message);
      // 	}
      // })
      setTimeout(() => {
        if (localStorage.getItem("agtuserImg")) {
          this.userImg = localStorage.getItem("agtuserImg");
        }
      }, 1500);
    },
    loginOut() {
      this.$confirm("真的要退出系统吗？").then(() => {
        const agtmainapi = JSON.parse(
          JSON.stringify(localStorage.getItem("agtmainapi"))
        );
        const agtkcmapi = JSON.parse(
          JSON.stringify(localStorage.getItem('agtkcmapi'))
        );
        localStorage.clear();
        localStorage.setItem("agtmainapi", agtmainapi);
        localStorage.setItem('agtkcmapi',agtkcmapi);
        this.$router.replace("/");
      });
    },
    closeAll() {
      this.historyList = [];
      this.historyIndex = -1;
      this.$router.replace("/home");
    },
    closeNow() {
      this.historyList.splice(this.historyIndex, 1);
      this.historyIndex = -1;
      this.$router.replace("/home");
    },
    closeOne(e, index) {
      if (index != this.historyIndex) {
        this.log("if");
        this.historyList.splice(index, 1);
        this.historyIndex--;
      } else {
        this.historyList.splice(index, 1);
        this.historyIndex = -1;
        this.log("else");
        this.$router.replace("/home");
      }
      // this.historyIndex=index-1
    },
    toHome() {
      this.log("tohome");
      this.$router.push({ path: "/home" });
      this.historyIndex = -1;
    },
    toauthpage(e) {
      if (
        e.code == "xtcsh" ||
        e.code == "sjwh" ||
        e.code == "rzzx" ||
        e.code == "xtsz" ||
        e.code == "sqzx"
      ) {
        if (this.isAsadmin || this.userinfo.fmobile == "13609283094") {
          this.historyList.push(e);
          this.historyIndex = this.historyList.length - 1;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", false);
          this.$router.push("/home/" + e.code);
        } else {
          this.$message.error("该账号暂无该操作权限");
        }
      } else if (e.code == "xtsz") {
        if (
          localStorage.getItem("agtcompany") == "undefined" ||
          this.isAsadmin
        ) {
          this.historyList.push(e);
          this.historyIndex = this.historyList.length - 1;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", false);
          this.$router.push("/home/" + e.code);
        } else {
          this.$message.error("该账号暂无改操作权限");
        }
      } else if (e.code == "9272") {
        if (
          this.userinfo.fmobile == "13609283094" ||
          this.userinfo.fmobile == "13332993762" ||
          this.userinfo.fmobile == "13332901386" ||
          this.userinfo.fmobile == "22000000005" ||
          this.userinfo.fmobile == "22000000004" ||
          this.userinfo.fmobile == "22000000003" ||
          this.userinfo.fmobile == "22000000002" ||
          this.userinfo.fmobile == "22000000001"
        ) {
          this.historyList.push(e);
          this.historyIndex = this.historyList.length - 1;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", false);
          this.$router.push("/home/" + e.code);
        } else {
          this.$message.error("该账号暂无该操作权限");
        }
      } else if (e.code == "xtpz") {
        // this.showxtpz = true;
        if (this.isAsadmin) {
          this.historyList.push(e);
          this.historyIndex = this.historyList.length - 1;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", false);
          this.$router.push("/home/" + e.code);
        } else {
          this.$message.error("该账号暂无该操作权限");
        }
      } else if (e.code == "bzzx") {
        this.historyList.push(e);
        this.historyIndex = this.historyList.length - 1;
        this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
        this.$Store.dispatch("onchangSetnaviName", e.name);
        this.$Store.dispatch("onchangIsfirst", false);
        this.$router.push("/home/" + e.code);
      } else {
        if (this.isAsadmin) {
          this.historyList.push(e);
          this.historyIndex = this.historyList.length - 1;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", false);
          this.$router.push("/home/" + e.code);
        } else {
          this.getAuthID(e);
        }
        this.log(e.code, e.fnaviid);
      }
    },
    getAuthID(e) {
      let userid = JSON.parse(localStorage.getItem("agtuserinfo")).fuserid;
      let usertel = JSON.parse(localStorage.getItem("agtuserinfo")).fmobile;
      let data = {
        system: "agt",
        naviid: e.fnaviid,
        douserid: userid,
        domobile: usertel,
      };
      this.$axios.post("user/auth/info", data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.asadmin || res.data.data.view) {
            this.historyList.push(e);
            this.historyIndex = this.historyList.length - 1;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.$router.push("/home/" + e.code);
          } else if (res.data.config.asadmin || res.data.config.view) {
            this.historyList.push(e);
            this.historyIndex = this.historyList.length - 1;
            this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", e.name);
            this.$Store.dispatch("onchangIsfirst", false);
            this.$router.push("/home/" + e.code);
          } else {
            this.$message.error("该账号暂无此权限");
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    historyTo(e, index) {
      this.historyIndex = index;
      this.$router.push("/home/" + e.code);
      this.$Store.dispatch("onchangIsfirst", false);
      this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
      this.$Store.dispatch("onchangSetnaviName", e.name);
    },
    toPage(e) {
      this.log("e", e);
      let isHave = false;
      this.historyList.forEach((el, index) => {
        if (el.code == e.code) {
          isHave = true;
          this.historyIndex = index;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", false);
          this.$router.push("/home/" + e.code);
        }
      });
      if (!isHave) {
        this.toauthpage(e);
      }
    },
    toPage2(e) {
      this.log(e);
      let isHave = false;
      this.historyList.forEach((el, index) => {
        if (el.code == e.code) {
          isHave = true;
          this.historyIndex = index;
          this.$Store.dispatch("onchangSetnaviid", e.fnaviid);
          this.$Store.dispatch("onchangSetnaviName", e.name);
          this.$Store.dispatch("onchangIsfirst", true);
          this.$router.push("/home/" + e.code);
        }
      });
      if (!isHave) {
        this.toauthpage(e);
      }
    },
    changeIsshow() {
      this.isshow = !this.isshow;
      if (this.$refs.rout.$refs.page) {
        // this.log(this.$refs.rout.$refs.page)
        if (this.$refs.rout.$refs.page.$refs.bill) {
          // this.log(this.$refs.rout.$refs.page.$refs.bill)
          this.$refs.rout.$refs.page.$refs.bill.shuaxinTableTop();
          this.$refs.rout.$refs.page.$refs.bill.shuaxinTableThree();
        }
      }
      if (this.isshow) {
        this.mainWidth = window.innerWidth - 150;
        this.$Store.dispatch("onchangLeftWidth", 150);
      } else {
        this.mainWidth = window.innerWidth - 50;
        this.$Store.dispatch("onchangLeftWidth", 50);
      }
    },
    /**个人信息 */
    getdata(data) {
      let that = this;
      if (data == "closeAll") {
        // 关闭所有窗口
        that.tabLists = [];
      } else if (data == "closeMe") {
        // 关闭当前窗口
        that.closeCurrentPage(that.tabSelect);
      } else {
      }
    },
    /**关闭当前页面 */
    closeCurrentPage(i) {
      this.closeNow();
      // this.log(i)
      return;
      let index = this.findIn(i, this.tabLists); // 获取当前页面下标
      this.tabLists.splice(index, 1); // 删除当前页面
      let numIndex = this.tabLists.length - 1; // 获取历史记录最后一个页面下标
      this.selectMenu(this.tabLists[numIndex]); // 触发跳转到历史记录最后一页
    },

    //查找下标事件
    findIn(i, arr) {
      let index = arr.findIndex((tag) => {
        return i == tag;
      });
      return index;
    },
    toHelp() {
      let obj = { code: "bzzx", fnaviid: 9996, name: "帮助中心" };
      this.toPage(obj);
    },
    // 选中top 事件
    selectEvent(i) {
      if (i.title == "主页") {
        this.asideShow = false;
        this.leftSelectArray = [];
        this.$router.push("/home");
      } else {
        this.asideShow = true;
      }

      let obj = {
        fname: i.title,
        fnaviid: i.gid,
      }; // 处理top list 方便 历史记录组件渲染
      this.tabLists = [obj]; // 记录top 模块到历史记录数组中
      this.topSelectArray = [i.title]; // 选中的top
      this.sort_books = i.children; // 选中top下的子集数组
    },
    // 切换页面
    toWhichPage(i) {
      this.log("zhes ", i);
    },
    // 选中left 事件
    selectMenu(i) {
      if (!this.tabLists) {
        this.tabLists = [];
      }
      let index = this.findIn(i, this.tabLists);
      if (index == -1) {
        this.tabLists.push(i);
      } else {
        this.tabLists.splice(index, 1, i);
      }
      this.tabSelect = i;
      // this.tabLists[1] = i
      this.leftSelectArray = [i.fname];
      if (this.topSelectArray.includes("决策分析")) {
        // 路由另处理，因为是动态数据报表
      } else {
        for (let item of this.sort_books) {
          if (item.fname == i.fname && item.fnaviid == i.fnaviid) {
            this.$router.push("/home/" + i.fnaviid);
            this.$Store.dispatch("onchangSetnaviid", i.fnaviid);
            this.$Store.dispatch("onchangSetnaviName", i.name);
          }
        }
      }
    },
    /**监听页面刷新*/
    listenPage() {
      let that = this;
      window.onbeforeunload = function (e) {
        e = e || window.event;

        // let token = localStorage.hasOwnProperty('agttoken')?localStorage.getItem('agttoken'):'';
        // if(!token){//如果没有令牌就跳转到登录页面
        //   that.$router.push("/home")
        // }
      };
    },
    /**确认用户登录的密码*/
    confirmUserInput() {
      this.$axios
        .post("auth/token", {
          mobile: this.uPhone,
          userpass: this.userInputPwd,
          visit: "web",
          system: "agt",
        })
        .then(({ data }) => {
          if (data.code == 0) {
            this.userInputPwd = "";
            this.inputPwdVisibile = false;
            localStorage.setItem("agttoken", data.data.token);
            localStorage.setItem("agtuserinfo", JSON.stringify(data));
          } else {
            this.$message.error(data.message);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./home";
.home {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue